import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNativeKeyboard } from "@/lib/nativeKeyboard";

// Fire-and-forget: hides the iOS accessory bar (^ v ✓) and starts publishing
// the keyboard height on --keyboard-h so composers can hug the keyboard.
initNativeKeyboard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
